import { createContext } from 'react'
import type { EnhancedManCodeId } from '#api/enhancements/enhancedTmsApiTypes'
import type { LocalConfigurationId } from '#app/store/slices/configurationSlice'

export const InternalConfigContext = createContext<{
  configurationId?: LocalConfigurationId | EnhancedManCodeId
}>({})
InternalConfigContext.displayName = 'ConfigurationContext'
